export const HEADER_LOGIN_EXCLUDED_URLS = [
  '/auth/login',
  '/auth/forget-password',
];
